export default __webpack_public_path__ + "static/atsmosphere-319f72b10c7cce6cb59db3eb3690010b.png";